import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { Subject } from 'rxjs/Subject';
  
import { GlobalComponent } from 'src/app/global/global.component';
import { ErrorService } from 'src/app/error.service';
import { getExcludedOigListeBase } from './operational-dashboard.modal';

@Injectable()

export class OigExceedDataServiceService extends Subject<DataStateChangeEventArgs>{
  constructor(private http: HttpClient, public errorService: ErrorService, public global: GlobalComponent) {
    super();
  }
  public execute(state: getExcludedOigListeBase): void {
    this.getLEIEList(state).subscribe(x => super.next(x));
  }
 
  getLEIEList(state?: getExcludedOigListeBase): Observable<DataStateChangeEventArgs> {
    return this.http.post<any>("api/Employee/GetSuspeciousEmployees", state)
      .pipe(map(
        (response: any) =>
          <any>{  
            result: response['result'],
            count: response['count']     
          }
      ))
  }  
}

